export default "__VITE_ASSET__S5lMWmU7__"